import { render, staticRenderFns } from "./ForLink.vue?vue&type=template&id=313691b7&scoped=true&"
import script from "./ForLink.vue?vue&type=script&lang=js&"
export * from "./ForLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313691b7",
  null
  
)

export default component.exports